import './styles.css'

import Star from '@mui/icons-material/Star';
import StarHalf from '@mui/icons-material/StarHalf';
import StarBorder from '@mui/icons-material/StarBorder';


export default function StarsBox({ config }) {
    const { value } = config

    return (
        <div className='stars-box' style={{ ...(config.style || {}) }}>
            <div className='stars-row'>
                {[...Array(5)].map((_, i) => {
                    const starValue = value - i;
                    if (starValue >= 0.7) {
                        return <Star key={i} className='star' />;
                    } else if (starValue >= 0.2) {
                        return <StarHalf key={i} className='star' />;
                    } else {
                        return <StarBorder key={i} className='star' />;
                    }
                })}
            </div>
            <p style={{
                color: (config.variant === "LIGHT" || !config.variant) ? 'var(--color-light)' : 'var(--color-dark)'
            }}>Nota {value} / 5</p>
        </div>
    )
}